import React, { useState } from 'react';
import { useLocationFilter } from '../context/LocationFilterContext';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DiscoverySettings = ({ onClose }) => {
  const { t } = useTranslation();
  const {
    filterType,
    setFilterType,
    locationFilterRadius,
    setLocationFilterRadius,
    languagePreference,
    setLanguagePreference,
  } = useLocationFilter();

  const handleRadiusChange = (e) => {
    setLocationFilterRadius(Number(e.target.value));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center">
      <div className="bg-slate-800 border border-slate-700 rounded-2xl shadow-2xl p-8 w-full max-w-md m-4 text-white">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-indigo-300">Discovery Settings</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <LucideIcons.X size={28} />
          </button>
        </div>

        <div className="space-y-8">
          {/* Feed Scope */}
          <div className="p-4 bg-slate-700/50 rounded-lg">
            <label className="block mb-3 font-semibold text-slate-300">Feed Scope</label>
            <div className="flex justify-between items-center space-x-2 bg-slate-900 p-1 rounded-full">
              {['local', 'country', 'global'].map((type) => (
                <button
                  key={type}
                  onClick={() => setFilterType(type)}
                  className={`w-full py-2 text-sm font-bold rounded-full transition-colors duration-300 ${
                    filterType === type ? 'bg-indigo-500 text-white' : 'text-slate-300 hover:bg-slate-700'
                  }`}
                >
                  {t(`settings.location.${type}`)}
                </button>
              ))}
            </div>
          </div>

          {/* Local Radius Slider */}
          <div className={`transition-all duration-500 ${filterType === 'local' ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0 overflow-hidden'}`}>
             <div className="p-4 bg-slate-700/50 rounded-lg">
                <label htmlFor="radius-slider" className="block mb-4 font-semibold text-slate-300">
                  Search Radius: <span className="font-bold text-indigo-300">{locationFilterRadius} km</span>
                </label>
                <div className="flex items-center gap-4">
                    <span className="text-xs text-slate-400">1 km</span>
                    <input
                        id="radius-slider"
                        type="range"
                        min="1"
                        max="250"
                        step="1"
                        value={locationFilterRadius}
                        onChange={handleRadiusChange}
                        className="w-full h-2 bg-slate-900 rounded-lg appearance-none cursor-pointer range-thumb-indigo"
                    />
                    <span className="text-xs text-slate-400">250 km</span>
                </div>
             </div>
          </div>

          {/* Language Preference */}
          <div className="p-4 bg-slate-700/50 rounded-lg flex items-center justify-between">
            <div>
                <label htmlFor="language-pref" className="font-semibold text-slate-300 cursor-pointer">Prefer My Language</label>
                <p className="text-xs text-slate-400">Prioritize content in your display language.</p>
            </div>
            <div className="forge-switch">
                <input
                    type="checkbox"
                    id="language-pref"
                    checked={languagePreference}
                    onChange={(e) => setLanguagePreference(e.target.checked)}
                />
                <span className="forge-slider"></span>
            </div>
          </div>
        </div>

        <div className="mt-8 text-right">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-indigo-600 text-white rounded-full font-semibold hover:bg-indigo-700 transition-colors"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscoverySettings;
